// extracted by mini-css-extract-plugin
export default {"userlist_container":"Procurement_userlist_container__Ske+g","container":"Procurement_container__eUpId","tile":"Procurement_tile__ShKQN","icon":"Procurement_icon__vn8N3"};